'use client';

import router from 'next/router';
import {locales} from '@i18n/config';
import {CustomImage} from '@/components';
import {CommonComponentContextProps} from './ComponentContext';
import Link from 'next/link';
import {DefaultLoading} from './DefaultLoading';

export const componentContext: CommonComponentContextProps = {
	hygraphMediaDomain: process.env.NEXT_PUBLIC_HYGRAPH_MEDIA_DOMAIN,
	Image: CustomImage,
	Link: Link,
	LoadingComponent: DefaultLoading,
	router,
	enableAuth: true,
	isRTL: false,
	locales
};
